export default "__VITE_ASSET__DUiME8Ff__"